document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('WidthInfoDrawer');
  if (!drawer) return;

  const overlay = drawer.querySelector('#WidthInfoDrawerOverlay');
  const inner = drawer.querySelector('.drawer__inner');
  const closeButton = drawer.querySelector('[data-width-drawer-close]');

  let lastTrigger = null;

  const normalizeText = (value) => {
    return (value || '').toString().trim().toUpperCase();
  };

  // Width labels use the canonical 5-bucket scale (Slim / Normal / Relaxed /
  // Wide / Extra Wide). The product's custom.width value and each guide row's
  // data-width-code are now the same label, so a trim+uppercase compare matches
  // directly — no code translation needed. (The old Standard (B) / Wide (D) /
  // Extra Wide (EE) → B/D/2E mapping was removed when remonte adopted the
  // rieker-aligned scale, 2026-06-01.)
  const normalizeWidth = (value) => normalizeText(value);

  const normalizeSize = (value) => {
    const normalized = (value || '').toString().trim();
    const match = normalized.match(/\d+/);
    return match ? match[0] : normalized;
  };

  const getTriggerWidth = (trigger) => {
    if (trigger.dataset.productWidth) {
      return trigger.dataset.productWidth;
    }

    const widthValueEl = trigger.querySelector('.width-value');
    return widthValueEl ? widthValueEl.textContent : '';
  };

  const getTriggerSize = (trigger) => {
    if (trigger.dataset.productSize) {
      return trigger.dataset.productSize;
    }

    const selectedSizeEl = trigger.querySelector('[data-selected-value]');
    return selectedSizeEl ? selectedSizeEl.textContent : '';
  };

  const updateFitButtonsFromSelectedVariant = () => {
    const selectedSize =
      document.querySelector('input[name*="Size"]:checked')?.value ||
      document.querySelector('select[name*="Size"]')?.value ||
      '';

    if (!selectedSize) return;

    document.querySelectorAll('[data-fit-button], [data-width-drawer-trigger][data-product-size]').forEach((button) => {
      button.dataset.productSize = selectedSize;
    });
  };

  const clearActiveStates = () => {
    drawer.querySelectorAll('.width-guide-row.is-active, .size-guide-row.is-active').forEach((row) => {
      row.classList.remove('is-active');
    });
  };

  const setActiveStates = (trigger) => {
    clearActiveStates();

    if (!trigger) return;

    const activeWidth = normalizeWidth(getTriggerWidth(trigger));
    const activeSize = normalizeSize(getTriggerSize(trigger));

    if (activeWidth) {
      drawer.querySelectorAll('.width-guide-row').forEach((row) => {
        const rowWidth = normalizeWidth(row.dataset.widthCode || '');

        if (rowWidth === activeWidth) {
          row.classList.add('is-active');
        }
      });
    }

    if (activeSize) {
      drawer.querySelectorAll('.size-guide-row').forEach((row) => {
        const rowSize = normalizeSize(row.dataset.sizeValue || '');

        if (rowSize === activeSize) {
          row.classList.add('is-active');
        }
      });
    }
  };

  const openDrawer = (trigger) => {
    lastTrigger = trigger || null;

    updateFitButtonsFromSelectedVariant();

    const skipHighlight = trigger?.hasAttribute('data-width-drawer-no-highlight');

    if (!skipHighlight) {
      setActiveStates(trigger);
    } else {
      clearActiveStates();
    }

    drawer.classList.add('active');

    if (inner) {
      inner.classList.add('active');
      inner.focus();
    }

    document.body.classList.add('overflow-hidden');
    drawer.setAttribute('aria-hidden', 'false');
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');

    if (inner) {
      inner.classList.remove('active');
    }

    document.body.classList.remove('overflow-hidden');
    drawer.setAttribute('aria-hidden', 'true');

    if (lastTrigger) {
      lastTrigger.focus();
    }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[type="radio"], select')) return;

    updateFitButtonsFromSelectedVariant();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-width-drawer-trigger]');
    if (!trigger) return;

    event.preventDefault();
    openDrawer(trigger);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('[data-width-drawer-trigger]');
    if (!trigger) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openDrawer(trigger);
    }
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });

  updateFitButtonsFromSelectedVariant();
});